import Pebble00 from '@/assets/images/Scenario/elements/Pebble00.png';
import Pebble01 from '@/assets/images/Scenario/elements/Pebble01.png';
import Pebble02 from '@/assets/images/Scenario/elements/Pebble02.png';
import Pebble03 from '@/assets/images/Scenario/elements/Pebble03.png';
import Pebble04 from '@/assets/images/Scenario/elements/Pebble04.png';
import Pebble05 from '@/assets/images/Scenario/elements/Pebble05.png';

export interface CapsuleScenarioOption {
  id: string;
  preview: string;
  background: string;
  commentObject: string;
  unlocked: boolean;
  price?: number;
  translationKey: 'balloon' | 'candle' | 'flashlight' | 'pebble';
  lockedImage?: string;
  commentPosition?: {
    top: number;
    left: number;
  };
  previewComment: {
    authorKey: string;
    textKey: string;
    dateKey: string;
    timestamp: string;
  };
}

export const CAPSULE_SCENARIOS: CapsuleScenarioOption[] = [
  {
    id: 'scenario-pebble',
    preview: '',
    background: '',
    commentObject: '',
    unlocked: true,
    translationKey: 'pebble',
    commentPosition: { top: 58, left: 36 },
    previewComment: {
      authorKey: 'capsuleScenarios.pebble.previewComment.author',
      textKey: 'capsuleScenarios.pebble.previewComment.text',
      dateKey: 'capsuleScenarios.pebble.previewComment.date',
      timestamp: '2024-06-21T20:15:00',
    },
  },
];

export const TUNNEL_STONE_ELEMENTS: string[] = [
  Pebble00,
  Pebble01,
  Pebble02,
  Pebble03,
  Pebble04,
  Pebble05,
];

export const getScenarioById = (id: string) => {
  const scenario = CAPSULE_SCENARIOS.find(item => item.id === id);
  return scenario ? getScenarioWithPurchaseStatus(scenario) : null;
};

export const getScenarioWithPurchaseStatus = (
  scenario: CapsuleScenarioOption
): CapsuleScenarioOption => scenario;

export const getScenariosWithPurchaseStatus = (): CapsuleScenarioOption[] => {
  return CAPSULE_SCENARIOS.map(getScenarioWithPurchaseStatus);
};
